/**
 * FloraHut Product Tabs & Mobile Accordion - Performance Optimized
 * Preserves 100% exact tab navigation, Judge.me deep-linking, note formatting, and accordion logic.
 */
(function() {
  function initTabs() {
    // Mobile accordion initialization: expand first item, collapse others
    if (window.innerWidth <= 767) {
      var allAcr = document.querySelectorAll('#PrSecTabs .prtabAcr');
      var allCnt = document.querySelectorAll('#PrSecTabs .tb_cnt');
      allAcr.forEach(function(a, idx) {
        if (idx === 0) {
          a.classList.add('active');
          if (allCnt[idx]) allCnt[idx].style.display = 'block';
        } else {
          a.classList.remove('active');
          if (allCnt[idx]) allCnt[idx].style.display = 'none';
        }
      });
    }

    function scrollToTarget(el) {
      if (!el) return;
      requestAnimationFrame(function() {
        setTimeout(function() {
          var headerEl = document.querySelector('.sticky_hdr, .hdr_wrap, header, #header, .header');
          var headerOffset = (headerEl && headerEl.offsetHeight ? headerEl.offsetHeight : 60) + 16;
          var rect = el.getBoundingClientRect();
          var targetY = rect.top + window.pageYOffset - headerOffset;
          window.scrollTo({
            top: Math.max(0, targetY),
            behavior: 'smooth'
          });
        }, 60);
      });
    }

    function openReviewTab(e) {
      if (e) {
        if (typeof e.preventDefault === 'function') e.preventDefault();
        if (typeof e.stopPropagation === 'function') e.stopPropagation();
      }

      var isMobile = window.innerWidth <= 767;
      var tabsSec = document.getElementById('PrSecTabs');
      var revCnt = document.getElementById('ptabReview');

      if (isMobile) {
        // Mobile Accordion Mode
        var allAcr = tabsSec ? tabsSec.querySelectorAll('.prtabAcr') : document.querySelectorAll('.prtabAcr');
        var allCnt = tabsSec ? tabsSec.querySelectorAll('.tb_cnt') : document.querySelectorAll('.tb_cnt');

        // Collapse other accordion panels so reviews is clean and visible
        allAcr.forEach(function(acr) {
          acr.classList.remove('active');
        });
        allCnt.forEach(function(cnt) {
          if (cnt !== revCnt) {
            cnt.style.display = 'none';
          }
        });

        // Expand the Review accordion item
        var acrHeader = null;
        if (revCnt) {
          revCnt.style.display = 'block';
          acrHeader = revCnt.previousElementSibling;
          if (acrHeader) {
            acrHeader.classList.add('active');
          }
        }

        // Scroll directly to the reviews accordion header
        var target = acrHeader || revCnt || document.getElementById('judgeme_product_reviews') || tabsSec;
        scrollToTarget(target);
      } else {
        // Desktop Tabs Mode
        var revTabLink = tabsSec ? tabsSec.querySelector('a[href="#ptabReview"]') : document.querySelector('a[href="#ptabReview"]');
        if (revTabLink) {
          var li = revTabLink.closest('li');
          if (li && li.parentElement) {
            li.parentElement.querySelectorAll('li').forEach(function(el) {
              el.classList.remove('active');
            });
            li.classList.add('active');
          }
        }

        // Hide other tabs, show review content
        var allCnt = tabsSec ? tabsSec.querySelectorAll('.tb_cnt') : document.querySelectorAll('.tb_cnt');
        allCnt.forEach(function(cnt) {
          if (cnt === revCnt) {
            cnt.style.display = 'block';
          } else {
            cnt.style.display = 'none';
          }
        });

        if (window.jQuery && revTabLink) {
          window.jQuery(revTabLink).trigger('click');
        }

        var target = tabsSec || revCnt || document.getElementById('judgeme_product_reviews');
        scrollToTarget(target);
      }
    }

    window.openProductReviewsTab = openReviewTab;

    // Handle clicks on review triggers in capture phase to prevent unwanted hash jumps
    document.addEventListener('click', function(e) {
      var trigger = e.target.closest(
        '.pr-rating-row, .pr-rating-count-link, .pr-rating-pill, a[href*="judgeme_product_reviews"], a[href*="ptabReview"], a[href*="reviews"], .jdgm-prev-badge, .jdgm-preview-badge, .loox-rating'
      );
      if (!trigger) return;

      // Do not intercept clicks inside the review app itself (e.g. pagination, star filter, write review form)
      if (trigger.closest('#ptabReview, #judgeme_product_reviews, .jdgm-review-widget, .jdgm-all-reviews-widget')) {
        return;
      }

      e.preventDefault();
      e.stopPropagation();
      openReviewTab(e);
    }, true);

    // Deep link support on initial page load / hash change
    if (window.location.hash === '#judgeme_product_reviews' || window.location.hash === '#ptabReview') {
      setTimeout(openReviewTab, 350);
    }
    window.addEventListener('hashchange', function() {
      if (window.location.hash === '#judgeme_product_reviews' || window.location.hash === '#ptabReview') {
        openReviewTab();
      }
    });
  }

  function formatDescriptionNote() {
    var descEls = document.querySelectorAll('.tb_pr_desc.fh-desc-body');
    descEls.forEach(function(descEl) {
      var blocks = descEl.querySelectorAll('p, div');
      blocks.forEach(function(el) {
        if (el.closest('.fh-desc-note-card') || el.classList.contains('fh-desc-note-card')) return;
        var txt = el.textContent.replace(/\u00a0/g, ' ').trim();
        if (/^\s*(?:please\s+note|note)\s*[:\-–—]?/i.test(txt)) {
          var card = document.createElement('div');
          card.className = 'fh-desc-note-card';

          var iconWrap = document.createElement('div');
          iconWrap.className = 'fh-desc-note-icon';
          iconWrap.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>';

          var textWrap = document.createElement('div');
          textWrap.className = 'fh-desc-note-text';

          while (el.firstChild) {
            textWrap.appendChild(el.firstChild);
          }

          if (txt.length <= 20 && el.nextElementSibling && el.nextElementSibling.tagName === 'P') {
            var nextP = el.nextElementSibling;
            textWrap.appendChild(document.createTextNode(' '));
            while (nextP.firstChild) {
              textWrap.appendChild(nextP.firstChild);
            }
            nextP.remove();
          }

          card.appendChild(iconWrap);
          card.appendChild(textWrap);
          el.replaceWith(card);
        }
      });

      // Remove any trailing empty elements (such as empty <p>, <p><br></p>, etc.) at the end of description
      var children = Array.from(descEl.children);
      for (var i = children.length - 1; i >= 0; i--) {
        var item = children[i];
        if (item.classList.contains('fh-desc-note-card')) break;
        var content = item.textContent.replace(/\u00a0/g, '').trim();
        if (!content && !item.querySelector('img, video, iframe, svg, table, canvas')) {
          item.remove();
        } else {
          break;
        }
      }
    });
  }

  function runAll() {
    initTabs();
    formatDescriptionNote();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runAll);
  } else {
    runAll();
  }
})();
